import React, { useState, useCallback } from "react";
// import Demo from "../../../public/Images/portfolio - img6.png";
// import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
// import Masonry from "react-masonry-css";
import Zoom from "react-reveal/Zoom";
import ImageViewer from "react-simple-image-viewer";

const Gallery = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const imgArray = [
    "images/Portfolio1.jpg",
    "images/Portfolio2.jpg",
    "images/Portfolio3.jpg",
    "images/Portfolio4.jpg",
    "images/Portfolio5.jpg",
    "images/Portfolio6.jpg",
    "images/Portfolio7.jpg",
    "images/Portfolio8.jpg",
    "images/Portfolio9.jpg",
    "images/Portfolio11.jpg",
  ];

  const breakpointColumnsObj = {
    default: 3,
    900: 3,
    750: 2,
    350: 1,
  };

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  });

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  return (
    <div id="Gallery" className="container-xxl py-4 team">
      <div className="container">
        <div className="text-center">
          <h6 className="section-title bg-white text-center text-primary px-3">
            <Zoom left>Gallery</Zoom>
          </h6>
          <Zoom right>
            <h1 className="mb-5 subtitle">Check Our Portfolio</h1>
          </Zoom>
        </div>
        {/* <img src="images/portfolio-img6.png" alt="Test Check" /> */}
        <div className="row">
          {/* <ResponsiveMasonry
            columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}
          > */}
          {/* <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          > */}

          {imgArray.map((item, index) => {
            console.log("sdfjkdsfnkjdsvn", item);
            return (
              <div className="col-md-6 col-sm-12 col-lg-4 col-12 p-2">
                <Zoom>
                  <img
                    src={item}
                    alt={`Test Check ${index}`}
                    className="imgSection"
                    onClick={() => openImageViewer(index)}
                  />
                </Zoom>
              </div>
            );
          })}
          {/* </Masonry> */}
          {/* </ResponsiveMasonry> */}
        </div>

        {isViewerOpen && (
          <ImageViewer
            src={imgArray}
            currentIndex={currentImage}
            onClose={closeImageViewer}
            disableScroll={false}
            backgroundStyle={{
              backgroundColor: "rgba(0,0,0,0.9)",
            }}
            closeOnClickOutside={true}
          />
        )}
      </div>
    </div>
  );
};

export default Gallery;
